import React, { useEffect, useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { addCount, disCount} from '../store'
import { useNavigate } from 'react-router-dom';

function Cart() {
    let cart = useSelector(state => state.cart);
    console.log(cart[1])
    let dispatch = useDispatch()
    const navigate = useNavigate();

    const total = () => {
        let sum = 0
        for (let i in cart) {
            sum += (cart[i].price * cart[i].amount)
        }
        return sum

    }

    let [delivery, setDelivery] = useState(0)

    useEffect(() => {
        if (total() >= 50000) {
            setDelivery(0)
        } else {
            setDelivery(3000)
        }
    }, [cart])



    return (
        <>
            <Container>


                <Row className='cartRow'>

                    <Col md={8} className='my-5'>

                        <Col className='caaa'>쇼핑백</Col>

                        {
                            cart.map((v, i) =>
                                <Row key={i}>
                                    <Col md={2} className='c1 my-5'><img src={process.env.PUBLIC_URL + v.imgUrl} alt="" className='imgsize' /></Col>
                                    <Col md={7} className='c2 my-5'>{v.item} <p>퍼퓸 비누</p><div><button className='cbtn me-2' onClick={() => { dispatch(disCount(v.id)) }}>-</button>{v.amount}<button className='cbtn mx-2' onClick={() => { dispatch(addCount(cart[i].id)) }}>+</button></div></Col>
                                    <Col md={3} className='c3 my-5 price4'>{v.price * v.amount}원</Col>
                                </Row>

                            )
                        }

                    </Col>

                    <Col md={4} className='my-5'>
                        <Row>
                            <Col className='caa'>결제내역</Col>

                            <Row>
                                <Col md={6} className='price'>주문 금액</Col>
                                <Col md={6} className='price3'><p className='d'>{total()}원</p></Col>
                            </Row>

                            <Row>
                                <Col md={6} className='price'>배송비</Col>
                                <Col md={6} className='price3'><p className='d'>{delivery}</p></Col>
                            </Row>

                            <Row>
                                <Col md={6} className='price'>총 금액</Col>
                                <Col md={6} className='price3'><p className='d'>{total() + delivery}</p></Col>
                            </Row>

                        </Row>

                        <button className='my5 m'>주문 계속하기</button><br />
                        <button className='my5 z' onClick={() => { navigate('/main') }}>쇼핑 계속하기</button>

                    </Col>

                </Row>









            </Container>


        </>
    )
}



export default Cart